import { toast } from 'react-toastify';

import { AssetUploadErrorType } from '@/types';

export const TOAST_POSITION = toast.POSITION.BOTTOM_RIGHT;
export const TOAST_CLASS = 'toast-message';

export const UPLOAD_ERROR_TRANSLATION_KEYS: Record<AssetUploadErrorType, string> = {
  [AssetUploadErrorType.UNSUPPORTED_MEDIA_FORMAT]: 'unsupportedMediaFormat',
  [AssetUploadErrorType.MAX_FILE_SIZE_EXCEEDED]: 'maxFileSizeError',
  [AssetUploadErrorType.INVALID_DURATION]: 'failedToRetrieveDuration',
  [AssetUploadErrorType.AUDIO_PROCESSING_FAILED]: 'uploadFailed',
  [AssetUploadErrorType.ASSET_TYPE_NOT_SUPPORTED]: 'assetTypeNotSupported',
  [AssetUploadErrorType.STORAGE_LIMIT_EXCEEDED]: 'storageLimitExceeded',
  [AssetUploadErrorType.TIME_LIMIT_EXCEEDED]: 'timeLimitExceeded',
  [AssetUploadErrorType.GENERIC_UPLOAD_ERROR]: 'assetError'
};
